import SidePanel from './side-panel';
export default SidePanel;
